import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { legacy_createStore as createStore } from 'redux';
import rootReducer from './reducers'
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'office-ui-fabric-core/dist/sass/Fabric.scss';
import '../node_modules/plyr/dist/plyr.css'
 
initializeIcons();
 
const store = createStore(rootReducer)
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<Provider store={store}>
    <App />
</Provider>);